/**
 * Adds a selected cell into a row-indexed map used to build selectedCells arrays.
 *
 * @param selectedCellMap - Mutable map of row IDs to selected column ID sets.
 * @param rowId - Row ID for the cell.
 * @param colId - Column ID for the cell.
 */
export const addSelectedCell = (
  selectedCellMap: Map<string, Set<string>>,
  rowId: string,
  colId: string,
): void => {
  const rowCols = selectedCellMap.get(rowId) ?? new Set<string>();
  rowCols.add(colId);
  selectedCellMap.set(rowId, rowCols);
};
